import { AiFillCaretRight } from '@react-icons/all-files/ai/AiFillCaretRight';
import React from 'react';
export const CaretRight = ({ size, color }) => (<AiFillCaretRight color={color} size={size}/>);
